export const sendOpenAuthPopupEvent = (
  description = ''
) => {
  document.dispatchEvent(
    new CustomEvent('openAuthPopup', {
      detail: description
    })
  );
};
